import { sessaoFetch, sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/roteiro/${id}`)
}
export async function getRoteiros (dados) {
  return sessaoFetchLoading(`base`, `/contrato?` + serialize(dados), 'GET')
}
export async function roteirosSelect () {
  return sessaoFetchLoading(`base`, `/roteiro?all=1`)
}
export async function add (dados) {
  return sessaoFetchLoading(`base`, `/roteiro`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/roteiro/${dados.id}`, 'PUT', dados)
}
export async function del (dados) {
  let retorno = await sessaoFetchLoading(`base`, `/roteiro/${dados}`, 'DELETE')
  return retorno
}
export async function getRoteirosDash (dados) {
  return sessaoFetchLoading(`base`, `/contrato?` + serialize(dados), 'GET')
}
export async function listByProdutoInstituicao (parametros) {
  let query = '?all=1'
  if (parametros.instituicao) query += `&instituicao_id=${parametros.instituicao}`
  if (parametros.produto) query += `&produto_id=${parametros.produto}`
  return sessaoFetch(`base`, `/roteiro${query}`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/roteiro.js